import React, { useState } from 'react'
import { ref, set, push, getDatabase } from 'firebase/database';
import { app } from '../firebase/firebase';
const database = getDatabase(app);
function Contact() {
    const [username, setUserName] = useState("")
    const [email, setEmail] = useState("")
    const [subject, setSubject] = useState("")
    const [message, setMessage] = useState("")
    const [load, setLoad] = useState(false)
    const handleUpload = (e) => {
        setLoad(true)
        e.preventDefault();

        const usersRef = ref(database, 'contact'); // 'users' is the collection
        const newUserRef = push(usersRef);
        set(newUserRef, {
            usernmae: username,
            email: email,
            subject: subject,
            message: message,
            date: new Date().toISOString()
        })
            .then(() => {
                console.log("Data uploaded successfully!");
                alert("Message uploaded successfully!")
                setUserName("")
                setEmail("")
                setSubject("")
                setMessage("")
                setLoad(false)


            })
            .catch((error) => {
                setLoad(false)

                console.error("Error uploading data: ", error);
            });
    };
    return (
        <section id="contact" className="contact">
            <div className="container align-items-center justify-content-center">
                <div className="section-title" data-aos="fade-up">
                    <h2>Contact Us</h2>
                </div>

                <div className="row align-items-center justify-content-center ">

                    <div className="col-lg-6 col-md-6  d-flex align-items-center justify-content-center" data-aos="fade-up" data-aos-delay="200">
                        <div className="info">
                            <div>
                                <i className="ri-mail-send-line"></i>
                                <p>
                                    <a href='https://mail.google.com/mail/u/0/#inbox?compose=new&to=saboordeveloper00@gmail.com' target="_blank" rel="noopener noreferrer" >
                                        saboordeveloper00@gmail.com
                                    </a>
                                </p>
                            </div>
                            <div>
                                <i className="ri-phone-line"></i>
                                <p> <a href="tel:+923064688521">+923064688521</a> <span> <a href="tel:+923174452231">+923174452231</a></span></p>
                            </div>
                            <div>
                                <i className="icofont-linkedin" />
                                <p> <a href="https://www.linkedin.com/in/abdul-saboor-0912a8218" class="linkedin" target="_blank">Abdul Saboor</a></p>

                            </div>
                            <div>
                                <i className="icofont-whatsapp" />
                                <p> <a href="https://wa.me/923064688521" target="_blank">Chat on WhatsApp</a></p>

                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-12 " data-aos="fade-up" data-aos-delay="300">
                        <form onSubmit={(e) => handleUpload(e)}>
                            <div className="form-group">
                                <input type="text" name="name" required className="form-control" id="name" placeholder="Your Name" value={username} onChange={(e) => setUserName(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <input type="email" className="form-control" required name="email" id="email" placeholder="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" required name="subject" id="subject" placeholder="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <textarea className="form-control" name="message" required rows="5" placeholder="Message" value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
                            </div>
                            <div className="text-center">
                                {
                                    !load &&
                                <button className="btn btn-success" type="submit" name="send">Send Message</button>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact